import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import Spinner from "../../../../reusableComponents/spinner/spinner";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { enableProduct } from "../../../../../store/thunks/systemManagementThunk";

interface EnableProductDialogProps {
  open: any;
  handleEnableProductClose: any;
  enableProductData: any;
}

const EnableProductDialog = (props: EnableProductDialogProps) => {
  const dispatch = useAppDispatch();
  const { open, handleEnableProductClose, enableProductData } = props;

  const { addProductLoading } = useAppSelector(
    (state: any) => state.systemManagement
  );

  const [enableProductError, setEnableProductError] = useState(false);
  const [enableProductErrorMessage, setEnableProductErrorMessage] =
    useState("");

  const handleEnableProduct = (message: string, reason?: any) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    handleEnableProductClose(message);
  };

  const submitEnableProduct = () => {
    dispatch(
      enableProduct({ product_index: enableProductData?.product_index })
    ).then((result: any) => {
      if (result.payload.result === true) {
        handleEnableProductClose(result.payload.message);
      } else {
        setEnableProductError(true);
        setEnableProductErrorMessage(result.payload.message);
      }
    });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      onClose={(event, reason) => handleEnableProduct("", reason)}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(59, 147, 74, 1)",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "white" }}>
          Enable Product
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => handleEnableProduct("")}
          sx={{
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Spinner loading={addProductLoading} />
      <DialogContent>
        <DialogContentText>
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center", padding: "10px" }}
          >
            Are you sure that you want to Enable Product:{"  "}
            <span style={{ fontWeight: "bold", padding: "0 5px 0 5px" }}>
              {" "}
              {enableProductData?.name}{" "}
            </span>
            with Price:
            <span style={{ fontWeight: "bold", padding: "0 5px 0 5px" }}>
              {enableProductData?.price}
            </span>
          </Grid>
          {enableProductError && (
            <Grid
              container
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Typography sx={{ color: "red" }}>
                {enableProductErrorMessage}
              </Typography>
            </Grid>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid" }}>
        <Button
          variant="outlined"
          onClick={() => handleEnableProduct("")}
          sx={{
            padding: "5px 10px 5px 10px",
            backgroundColor: "red",
            color: "black",
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="outlined"
          sx={{
            padding: "5px 10px 5px 10px",
            backgroundColor: "rgba(59, 147, 74, 1)",
            color: "white",
          }}
          onClick={() => submitEnableProduct()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnableProductDialog;
